import { initWidget } from './widget';
import endpoints from './widget/define/endpoints';

import { ModalPartnerSignup } from './widget/component/modals';
import ContactForm from './widget/component/ContactForm';

const initPartnershipPageWidgets = () => {
    const props = {
        endpoints,
    };

    initWidget('modal-partner-signup', ModalPartnerSignup, props);
    initWidget('contact-form', ContactForm, props);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPartnershipPageWidgets.bind(this));
} else {
    initPartnershipPageWidgets();
}